import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ColorClass, OrderItemState } from 'shared';

@Component({
    selector: 'app-order-item-state',
    templateUrl: './order-item-state.component.html',
    styleUrls: ['./order-item-state.component.scss'],
})
export class OrderItemStateComponent implements OnChanges {
    public iconName: string;
    public iconColor: ColorClass;
    @Input() public orderItemState: OrderItemState;

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        this.setState();
    }

    setState(): void {
        switch (this.orderItemState) {
            case OrderItemState.Collected:
            case OrderItemState.Replaced:
                this.iconName = 'basket-outline';
                this.iconColor = ColorClass.Primary;
                break;
            case OrderItemState.NotFound:
                this.iconName = 'eye-off-outline';
                this.iconColor = ColorClass.Dark;
                break;
            case OrderItemState.Approved:
                this.iconName = 'thumbs-up-outline';
                this.iconColor = ColorClass.Success;
                break;
            case OrderItemState.Declined:
                this.iconName = 'thumbs-down-outline';
                this.iconColor = ColorClass.Danger;
                break;
        }
    }
}
